import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';

import rootReducer from '@store/reducers';
import { baseApi } from '@store/api/baseApi';

const store = configureStore({
	reducer: rootReducer,
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({ immutableCheck: false, serializableCheck: false }).concat(baseApi.middleware),
	devTools: process.env.NODE_ENV !== 'production'
});

setupListeners(store.dispatch);

export default store;
